/**
 * API Configuration
 * Centralized configuration for all API settings
 */

const API_CONFIG = {
  // Base URLs for different environments
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://diardzair.dz",
  STOCK_BASE_URL: process.env.REACT_APP_STOCK_API_URL || "https://diardzairstocks.store",
  PDF_BASE_URL: process.env.REACT_APP_PDF_API_URL || "https://diardzair.tech",

  // Request timeout in milliseconds
  TIMEOUT: 30000,

  // Default headers
  DEFAULT_HEADERS: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};

export default API_CONFIG;
